const mustache = (text: string, data: Record<string, string> = {}) =>
  Object.entries(data).reduce((res, [key, value]) => res.replace(new RegExp(`{\\s*${key}\\s*}`, 'g'), value), text)

export default mustache
